import { TypeOf, yup } from '@guiker/yup-util'

import { Ontario } from '../../../entity'

export const tenantsInsurance = yup.object<Omit<Ontario.TenantsInsurance, 'completed'>>({
  isTenantsInsuranceRequired: yup.boolean().required(),
})

export type TenantsInsurance = TypeOf<typeof tenantsInsurance>
